import _ from 'underscore';

import { ModelType } from '@biteinc/enums';
import { MathHelper } from '@biteinc/helpers';

import { getOrderFinancialsText, getOrderGuestInfoText } from '../helpers/order_details_helper';
import { TimeHelper } from '../helpers/time_helper';

function orderedItemText(orderedItem, indentation = '', prefix = '') {
  const priceOption = orderedItem.priceOption;
  const priceOptionName = priceOption.name ? `${priceOption.name}: ` : '';

  let text = `${indentation}${prefix}${priceOption.quantity}× ${orderedItem.name}`;
  text += ` (${priceOptionName}$${MathHelper.displayPrice(priceOption.unitPrice)})\n`;

  priceOption.modGroups?.forEach((modGroup) => {
    text += `${indentation}   ${modGroup.name}\n`;
    modGroup.items.forEach((mod) => {
      text += orderedItemText(mod, `${indentation}   `, '+ ');
    });
    modGroup.deselectedItems?.forEach((mod) => {
      text += orderedItemText(mod, `${indentation}   `, '- NO ');
    });
  });

  if (orderedItem.specialRequest) {
    text += `${indentation}Special Request: ${orderedItem.specialRequest}\n`;
  }

  return text;
}

app.ThirdPartyOrder = app.AbstractModel.extend({
  ModelName: 'thirdPartyOrder',
  Schema: {
    displayName: 'third party order',
  },
  Type: ModelType.ThirdPartyOrder,

  url() {
    return `/api/v2/third-party-orders/${this.id}`;
  },

  _getSummaryLines() {
    const lines = [`Order: ${this.get('clientNumber') || this.id}`];

    const guestInfoText = getOrderGuestInfoText(this.attributes);
    if (guestInfoText) {
      lines.push(`Guest: ${guestInfoText}`);
    }

    if (this.get('deliveryAddress')) {
      lines.push(`Delivery Address: ${this.get('deliveryAddress')}`);
    }

    if (this.get('tableNumber')) {
      lines.push(`Table: ${this.get('tableNumber')}`);
    }

    if (this.get('fulfillmentOrderIds')?.length) {
      lines.push(`Fulfillment Check ID: ${this.get('fulfillmentOrderIds').join(', ')}`);
    }

    return lines;
  },

  displayNameHtml() {
    let html = '';

    if (this.get('isBiteFutureOrder')) {
      html += '<span class="badge badge-pill badge-info">Future Order</span><br />';
    }
    if (this.get('pickupAt')) {
      const pickupTime = TimeHelper.displayDateFromTimestamp(
        this.get('pickupAt'),
        app.location.get('timezone'),
      );
      html += `<span class="badge badge-pill badge-secondary">Pickup: ${_.escape(pickupTime)}</span><br />`;
    }

    html += this._getSummaryLines().map(_.escape).join('<br />');

    let warningLabel = '';
    if (!this.get('isParsed')) {
      warningLabel = 'UNPARSED';
    } else if (this.get('hasFailedToSend')) {
      warningLabel = 'FAILED TO SEND';
    } else if (!this.get('sentAt')) {
      warningLabel = 'UNSENT';
    }

    const itemsText = (this.get('orderedItems') || [])
      .map((item) => orderedItemText(item))
      .join('\n');

    let warningAttr = warningLabel ? ` warning="${warningLabel}"` : '';
    html += `<div class="ordered-items text-break"><pre alt="Ordered Items"${warningAttr}>${_.escape(itemsText)}</pre></div>`;

    if (this.get('isParsed')) {
      html += `<pre alt="totals">${_.escape(getOrderFinancialsText(this.attributes, !!this.get('appliedRewards')?.length))}</pre>`;
    }

    return html;
  },

  copyableDetailsText() {
    const createdAtText = TimeHelper.displayDateFromTimestamp(
      this.get('createdAt'),
      app.location.get('timezone'),
    );
    const lines = this._getSummaryLines();
    lines[0] += ` (${createdAtText})`;

    if (this.get('isParsed')) {
      lines.push(getOrderFinancialsText(this.attributes, !!this.get('appliedRewards')?.length));
    }

    return lines.join('\n');
  },
});
